import Api from "../../api/api.main";

// ส่ง credential ใน POST body และคืนเฉพาะ Profile ที่ผ่านการยืนยันจาก backend
export const loginWithUsername = async (credentials, client = Api) => {
  const response = await client.post("/auth/login", credentials);
  const profile = response?.data?.profile;
  if (!profile?._id) {
    const error = new Error("Authenticated Profile is missing");
    error.code = "PROFILE_MISSING";
    throw error;
  }
  return profile;
};
